import { render, staticRenderFns } from "./EventComponent.vue?vue&type=template&id=bbf2cbca&scoped=true&"
import script from "./EventComponent.vue?vue&type=script&lang=ts&"
export * from "./EventComponent.vue?vue&type=script&lang=ts&"
import style0 from "./EventComponent.vue?vue&type=style&index=0&id=bbf2cbca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf2cbca",
  null
  
)

export default component.exports